import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-tabs" }
const _hoisted_2 = { class: "app-tabs__header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "app-tabs__content" }

import { watch, onMounted } from "vue";

type tabModel = {
  id: string | number;
  title: string;
  slotName?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTabsOld',
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "tab-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Устанавливаем первый таб по умолчанию
onMounted(() => {
  if (props.modelValue === undefined && props.tabs.length > 0) {
    emit("update:modelValue", props.tabs[0].id);
  }
});

// Следим за сменой активного таба
watch(
  () => props.modelValue,
  (newTabId) => {
    if (newTabId !== undefined) {
      const activeTab = props.tabs.find((tab) => tab.id === newTabId);
      if (activeTab) {
        emit("tab-change", activeTab);
      }
    }
  },
);

// Если tabs меняются
watch(
  () => props.tabs,
  (newTabs) => {
    if (props.modelValue === undefined && newTabs.length > 0) {
      emit("update:modelValue", newTabs[0].id);
    }
  },
  { immediate: true },
);

const setActiveTab = (tabId: string | number) => {
  emit("update:modelValue", tabId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.id,
          class: _normalizeClass(['app-tabs__header-button', { active: _ctx.modelValue === tab.id }]),
          onClick: ($event: any) => (setActiveTab(tab.id))
        }, _toDisplayString(tab.title), 11, _hoisted_3))
      }), 128)),
      _renderSlot(_ctx.$slots, "additionalContent")
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "app-tabs__content-tab",
          key: tab.id
        }, [
          _renderSlot(_ctx.$slots, tab.slotName)
        ])), [
          [_vShow, _ctx.modelValue === tab.id]
        ])
      }), 128))
    ])
  ]))
}
}

})